import { makeApiUrl, makeHttpClient } from '~/main/factories/http';
import { CreateOrgUnit as UseCaseRemoteCreateOrgUnit } from '~/domain/usecases/orgUnit/remote';

import { RemoteCreateOrgUnit } from '~/data/repository/orgUnit';

export const makeRemoteCreateOrgUnit = (): UseCaseRemoteCreateOrgUnit =>
  new RemoteCreateOrgUnit(makeApiUrl('/orgUnits'), makeHttpClient());
